import { RiPencilLine } from '@remixicon/react';
import { useMemo } from 'react';
import { AgButton, AgSwitch } from 'src/components/ui';
import { GridColObj } from 'src/modules/grids';
import { CustomerGroupsMeta, customerCount } from '../constants';
import useUpdateCustomerGroup from './useUpdateCustomerGroup';

export default function useCustomerGroupsColumns(setEditGroup): GridColObj {
  const editGroup = useUpdateCustomerGroup();

  return useMemo(
    () => ({
      name: { headerName: 'Name', type: 'string', flex: 1, minWidth: 300 },
      numberOfCustomers: {
        headerName: 'Number of customers',
        minWidth: 200,
        flex: 0.5,
        type: 'number',
        // Computed from the customers relation: customerGroupPage filters on it by count (#7627 F19), but
        // cannot sort it (BZ75).
        sortable: false,
        valueGetter: (_value, row) => customerCount(row as CustomerGroupsMeta),
      },
      updatedAt: {
        headerName: 'Last updated',
        flex: 0.5,
        type: 'string',
        // A DateTime column: a server-side text filter cannot match it, so only sort stays (BZ75).
        filterable: false,
        valueFormatter: (value) => (value ? new Date(value).toLocaleDateString() : '--'),
      },
      actions: {
        headerName: '',
        disableExport: true,
        resizable: false,
        sortable: false,
        filterable: false,
        minWidth: 100,
        width: 100,
        renderCell: ({ row }) => {
          const group = row as CustomerGroupsMeta;
          return (
            <div className="flex items-center gap-1">
              <AgSwitch isSelected={group.enabled} onChange={() => editGroup(group.id, { enabled: !group.enabled })} />
              <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => setEditGroup(group)}>
                <RiPencilLine size={20} />
              </AgButton>
            </div>
          );
        },
      },
    }),
    [setEditGroup, editGroup]
  );
}
